import { useEffect, useState } from "react";
import { CLINIC } from "../clinic";
import "./Navbar.css";

const links = [
  { href: "#home", label: "Home" },
  { href: "#appointment", label: "Appointment" },
  { href: "#contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <header className="site-header">
      <nav className="navbar container">
        <a href="#home" className="logo" onClick={() => setOpen(false)}>
          SmileHub
        </a>

        <button
          className={`menu-toggle ${open ? "open" : ""}`}
          type="button"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          onClick={() => setOpen((value) => !value)}
        >
          <span />
          <span />
          <span />
        </button>

        <ul className={`nav-links ${open ? "show" : ""}`}>
          {links.map((link) => (
            <li key={link.href}>
              <a href={link.href} onClick={() => setOpen(false)}>
                {link.label}
              </a>
            </li>
          ))}
          <li className="nav-call-mobile">
            <a
              className="btn"
              href={`tel:${CLINIC.phone}`}
              onClick={() => setOpen(false)}
            >
              Call: {CLINIC.phoneDisplay}
            </a>
          </li>
        </ul>

        <a href={`tel:${CLINIC.phone}`} className="btn nav-call">
          Call: {CLINIC.phoneDisplay}
        </a>
      </nav>
    </header>
  );
}
